import PropTypes from 'prop-types'
import React from 'react'
import styles from './_myRoutesModule.css'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { FormattedDistance } from 'shared/units'

export function RouteRow ({ route, onClick }) {
  return (
    <tr className={styles.tr} onClick={onClick}>
      <td className={styles.td}>
        <div className={styles.cellDistance}>
          <FormattedDistance
            id='routes.my_routes_module.row.distance'
            value={route.distance}
            digits={2}
          />
        </div>
      </td>
      <td className={styles.td}>
        <div className={styles.cellInfo}>
          <img
            className={styles.routeThumbnail}
            src={route._links.thumbnail[0].href}
          />
          <div>
            <div className={styles.routeTitle}>{route.name}</div>
            <div className={styles.routeCreated}>
              <FormattedDate value={route.created_datetime} />
            </div>
          </div>
        </div>
      </td>
      <td className={styles.td}>
        <div className={styles.cellLocation}>
          <FormattedMessage
            id='routes.my_routes_module.row.location'
            defaultMessage='{city}, {state}, {country}'
            values={{
              city: route.city,
              state: route.state,
              country: route.country && route.country.toUpperCase(),
            }}
          />
        </div>
      </td>
    </tr>
  )
}

RouteRow.propTypes = {
  onClick: PropTypes.func,
  route: PropTypes.shape({
    name: PropTypes.string,
    created_datetime: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    distance: PropTypes.number,
    _links: PropTypes.shape({
      thumbnail: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string,
      })),
    }),
  }),
}

export default RouteRow
